import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "nav-link",
  href: "/notifications"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("a", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("i", { class: "bi bi-bell-fill" }, null, -1)),
    _withDirectives(_createElementVNode("span", { class: "badge-notification badge badge-primary bg-primary" }, _toDisplayString(_ctx.state.display.value), 513), [
      [_vShow, _ctx.state.counter.value > 0]
    ])
  ]))
}